import { Colors } from '@ab-core/colors';
import styled from 'styled-components';

export const StyledNameContainer = styled.div`
    color: ${Colors.black};
`;

export const TextContainer = styled.div`
    height: 2.5rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;
